// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1CeY7","tabsBox":"styles_tabsBox__3NPEc","createButton":"styles_createButton__3uAKK"};